// extracted by mini-css-extract-plugin
module.exports = {"menu-color":"rgba(255,255,255,.95)","menu-color-active":"rgba(255,255,255,.95)","menu-background":"#282c34","column-second-menu-background":"#fff","vab-border-radius":"2.5px"};